import React, { useState, useEffect } from 'react';
import { reportsApi } from '../../services/api';

function ReportList() {
  const [postReports, setPostReports] = useState([]);
  const [commentReports, setCommentReports] = useState([]);
  const [activeTab, setActiveTab] = useState('posts');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchReports = async () => {
    setIsLoading(true);
    try {
      const [postRes, commentRes] = await Promise.all([
        reportsApi.listPostReports(),
        reportsApi.listCommentReports(),
      ]);
      setPostReports(postRes.data.reports);
      setCommentReports(commentRes.data.reports);
    } catch (err) {
      setError('Fehler beim Laden der Reports');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchReports(); }, []);

  const handleResolve = async (type, reportId, action) => {
    const note = prompt('Notiz hinzufügen (optional):');
    try {
      if (type === 'post') {
        await reportsApi.resolvePostReport(reportId, action, note);
      } else {
        await reportsApi.resolveCommentReport(reportId, action, note);
      }
      fetchReports();
    } catch (err) {
      alert('Aktion fehlgeschlagen');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('de-DE', {
      day: '2-digit', month: '2-digit', year: 'numeric',
    });
  };

  const reports = activeTab === 'posts' ? postReports : commentReports;
  const totalPending = postReports.length + commentReports.length;

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Reports</h1>
        <p className="page-subtitle">{totalPending} offene Reports</p>
      </div>

      <div className="tabs">
        <button className={`tab ${activeTab === 'posts' ? 'active' : ''}`} onClick={() => setActiveTab('posts')}>
          Beiträge ({postReports.length})
        </button>
        <button className={`tab ${activeTab === 'comments' ? 'active' : ''}`} onClick={() => setActiveTab('comments')}>
          Kommentare ({commentReports.length})
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {isLoading ? (
        <div className="loading-container"><div className="loading-spinner"></div></div>
      ) : reports.length === 0 ? (
        <div className="empty-state">Keine offenen Reports</div>
      ) : (
        <div className="reports-list">
          {reports.map((report) => (
            <div key={report.id} className="report-card">
              <div className="report-header">
                <span className="report-reason">{report.reason}</span>
                <span className="report-date">{formatDate(report.created_at)}</span>
              </div>
              <div className="report-content">
                <p><strong>Gemeldet von:</strong> {report.reporter_name}</p>
                <p><strong>Autor:</strong> {activeTab === 'posts' ? report.post_author_name : report.comment_author_name}</p>
                <div className="reported-content">
                  {activeTab === 'posts' ? (
                    <>
                      {report.post_title && <p><strong>{report.post_title}</strong></p>}
                      <p>{report.post_content}</p>
                    </>
                  ) : (
                    <p>{report.comment_content}</p>
                  )}
                </div>
              </div>
              <div className="report-actions">
                <button onClick={() => handleResolve(activeTab === 'posts' ? 'post' : 'comment', report.id, 'delete')} className="action-btn delete">
                  Löschen
                </button>
                <button onClick={() => handleResolve(activeTab === 'posts' ? 'post' : 'comment', report.id, 'warn')} className="action-btn warn">
                  Warnen
                </button>
                <button onClick={() => handleResolve(activeTab === 'posts' ? 'post' : 'comment', report.id, 'dismiss')} className="action-btn dismiss">
                  Abweisen
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ReportList;
